import type { HoComponents } from '@pos/api-client';
import { crudApi } from '@pos/admin-ui';
import { hoApi } from '../api';

type StoreGroup = HoComponents['schemas']['StoreGroupDto'];
type StoreGroupMember = HoComponents['schemas']['StoreGroupMemberDto'];

/** A brand has a handful of groups, and a group at most a few hundred stores: one page holds them. */
const ALL = 500;

/** Store groups (ADR 0115), of one brand when given; reading them needs `ho.org.read`. */
export async function loadStoreGroups(brandId?: string | null): Promise<StoreGroup[]> {
  const groups = crudApi<StoreGroup, never>(hoApi, '/api/v1/identity/store-groups');
  return (await groups.list({ pageSize: ALL, ...(brandId ? { brandId } : {}) })).items;
}

/** The ids of the stores in a group. */
export async function loadStoreGroupStoreIds(groupId: string): Promise<string[]> {
  const members = crudApi<StoreGroupMember, never>(hoApi, `/api/v1/identity/store-groups/${groupId}/stores`);
  return (await members.list({ pageSize: ALL })).items.map((m) => m.storeId);
}
